import { Fragment, useEffect, useState } from "react";
import { base64Encode } from "../../Layout/Common/common";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { Link } from "react-router-dom";

export const WesCatalogueCard = ({ index, viewBox, UserResponse }) => {
  const baseDirectory = process.env.REACT_APP_publicUrl || window.location.origin;
  const [ebookHref, setEbookHref] = useState("");
  const [pdfHref, setPdfHref] = useState("");
  const [item, setItem] = useState(null);

  useEffect(() => {
    if (UserResponse) {
      setItem(UserResponse);
      let ebookHref = "/ViewEbook/" + base64Encode(UserResponse.ebooklink);
      const pdfHref = ("/document/" + UserResponse.pdflink).replace("/media/", "/mediapub/");

      setEbookHref(ebookHref);
      setPdfHref(pdfHref);
    }
  }, [UserResponse]);

  return (
    <Fragment>
      {item && (
        <div
          key={`CatalogueItemKey_${index}`}
          className={`${viewBox === "grid" ? "col-6 col-sm-4 col-md-6 col-lg-4 mb-3 mb-md-4" : "col-md-12 mb-3"} `}
        >
          <div className={`card ${viewBox === "grid" ? "catalogue-card" : "catalogue-row"}`}>
            <Link to={ebookHref} target="_blank" className="catalogue-img">
              <ImageWithDefault src={item.catalogueImage} alt={item.name} classList="w-100" />
            </Link>
            <div className="card-body">
              <h5 className="card-title">
                <Link to={ebookHref} target="_blank">
                  {item.name}
                </Link>
              </h5>
              <p className="card-text">{item.desc ? item.desc.replace(/<[^>]+>/g, "") : ""}</p>
              <div className="catalogue-downloadEbook">
                <Link to={ebookHref} target="_blank" className="pe-2">
                  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_6543_4714)">
                      <path
                        d="M7.99931 2.22786C6.18819 2.22786 4.69931 3.05009 3.55764 4.10842C2.48819 5.10286 1.74931 6.28342 1.37153 7.11675C1.74931 7.95009 2.48819 9.13064 3.55486 10.1251C4.69931 11.1834 6.18819 12.0056 7.99931 12.0056C9.81042 12.0056 11.2993 11.1834 12.441 10.1251C13.5104 9.13064 14.2493 7.95009 14.6271 7.11675C14.2493 6.28342 13.5104 5.10286 12.4438 4.10842C11.2993 3.05009 9.81042 2.22786 7.99931 2.22786ZM2.64931 3.13342C3.95764 1.91675 5.75486 0.894531 7.99931 0.894531C10.2438 0.894531 12.041 1.91675 13.3493 3.13342C14.6493 4.34175 15.5187 5.78342 15.9326 6.77509C16.0243 6.99453 16.0243 7.23898 15.9326 7.45842C15.5187 8.45009 14.6493 9.89453 13.3493 11.1001C12.041 12.3168 10.2438 13.339 7.99931 13.339C5.75486 13.339 3.95764 12.3168 2.64931 11.1001C1.34931 9.89453 0.479861 8.45009 0.06875 7.45842C-0.0229167 7.23898 -0.0229167 6.99453 0.06875 6.77509C0.479861 5.78342 1.34931 4.33898 2.64931 3.13342ZM7.99931 9.33897C9.22708 9.33897 10.2215 8.34453 10.2215 7.11675C10.2215 5.88898 9.22708 4.89453 7.99931 4.89453C7.97986 4.89453 7.96319 4.89453 7.94375 4.89453C7.97986 5.0362 7.99931 5.1862 7.99931 5.33898C7.99931 6.31953 7.20208 7.11675 6.22153 7.11675C6.06875 7.11675 5.91875 7.09731 5.77708 7.0612C5.77708 7.08064 5.77708 7.09731 5.77708 7.11675C5.77708 8.34453 6.77153 9.33897 7.99931 9.33897ZM7.99931 3.5612C8.9423 3.5612 9.84667 3.9358 10.5135 4.6026C11.1803 5.26939 11.5549 6.17376 11.5549 7.11675C11.5549 8.05974 11.1803 8.96411 10.5135 9.63091C9.84667 10.2977 8.9423 10.6723 7.99931 10.6723C7.05631 10.6723 6.15194 10.2977 5.48515 9.63091C4.81835 8.96411 4.44375 8.05974 4.44375 7.11675C4.44375 6.17376 4.81835 5.26939 5.48515 4.6026C6.15194 3.9358 7.05631 3.5612 7.99931 3.5612Z"
                        fill="black"
                      ></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_6543_4714">
                        <rect width="16" height="14.2222" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                  <span className="d-inline ps-1 text-decoration-underline">View eBook</span>
                </Link>
                <Link
                  to={pdfHref}
                  style={{
                    display: item.pdfdisp,
                  }}
                  target="_blank"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_6543_4718)">
                      <path
                        d="M2 14.5H3.5V16H2C0.896875 16 0 15.1031 0 14V2C0 0.896875 0.896875 0 2 0H7.17188C7.70312 0 8.2125 0.209375 8.5875 0.584375L11.4156 3.4125C11.7906 3.7875 12 4.29688 12 4.82812V9.5H10.5V5H8C7.44688 5 7 4.55312 7 4V1.5H2C1.725 1.5 1.5 1.725 1.5 2V14C1.5 14.275 1.725 14.5 2 14.5ZM5.5 11H6.5C7.46562 11 8.25 11.7844 8.25 12.75C8.25 13.7156 7.46562 14.5 6.5 14.5H6V15.5C6 15.775 5.775 16 5.5 16C5.225 16 5 15.775 5 15.5V14V11.5C5 11.225 5.225 11 5.5 11ZM6.5 13.5C6.91563 13.5 7.25 13.1656 7.25 12.75C7.25 12.3344 6.91563 12 6.5 12H6V13.5H6.5ZM9.5 11H10.5C11.3281 11 12 11.6719 12 12.5V14.5C12 15.3281 11.3281 16 10.5 16H9.5C9.225 16 9 15.775 9 15.5V11.5C9 11.225 9.225 11 9.5 11ZM10.5 15C10.775 15 11 14.775 11 14.5V12.5C11 12.225 10.775 12 10.5 12H10V15H10.5ZM13 11.5C13 11.225 13.225 11 13.5 11H15C15.275 11 15.5 11.225 15.5 11.5C15.5 11.775 15.275 12 15 12H14V13H15C15.275 13 15.5 13.225 15.5 13.5C15.5 13.775 15.275 14 15 14H14V15.5C14 15.775 13.775 16 13.5 16C13.225 16 13 15.775 13 15.5V13.5V11.5Z"
                        fill="black"
                      ></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_6543_4718">
                        <rect width="16" height="16" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                  <span className="d-inline ps-1 text-decoration-underline">View PDF</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
